import { axios } from '@Root/API'

export const getById = institutionId => {
	return axios.get(`institutions/${institutionId}`)
}
